import { render } from "./MobileProposalPayment.vue?vue&type=template&id=9ac84e4c"
import script from "./MobileProposalPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileProposalPayment.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/MobileProposalPayment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ac84e4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ac84e4c', __exports__)) {
    api.reload('9ac84e4c', __exports__)
  }
  
  module.hot.accept("./MobileProposalPayment.vue?vue&type=template&id=9ac84e4c", () => {
    api.rerender('9ac84e4c', render)
  })

}


export default __exports__